var map = {
	"./InfoTooltip.svg": 82446,
	"./TextBubble.svg": 86053,
	"./add-contact-icon.svg": 14812,
	"./add-filter.svg": 24976,
	"./add-icon.svg": 18612,
	"./add-landing-icon.svg": 6266,
	"./add.svg": 70281,
	"./alert-icon.svg": 18097,
	"./all-customers.svg": 77477,
	"./amex.svg": 1836,
	"./arrow-down.svg": 1313,
	"./arrow-left.svg": 64210,
	"./arrow.svg": 48813,
	"./back-icon.svg": 95884,
	"./background.svg": 95892,
	"./bars.svg": 60569,
	"./box.svg": 73332,
	"./bullet.svg": 20215,
	"./calendar-icon.svg": 60983,
	"./calendar.svg": 16762,
	"./call-icon.svg": 49149,
	"./campaigns-running-icon.svg": 2524,
	"./clicks.svg": 88183,
	"./color.svg": 94431,
	"./coming-soon.svg": 24323,
	"./confirmTick.svg": 81908,
	"./connect-icon-inactive.svg": 59744,
	"./connect-icon.svg": 37516,
	"./connected.svg": 29556,
	"./connectedTick.svg": 63604,
	"./continue-icon.svg": 91053,
	"./create-campaign-icon.svg": 43675,
	"./crm-icon-inactive.svg": 22422,
	"./crm-icon.svg": 2202,
	"./customRedirectIcon.svg": 70610,
	"./customer-icon-inactive.svg": 32113,
	"./customer-icon.svg": 32068,
	"./dashboard-icon-inactive.svg": 21620,
	"./dashboard-icon.svg": 78000,
	"./dashboard-subitem-icon.svg": 9164,
	"./date-icon.svg": 86164,
	"./defaultJoinImage.svg": 67196,
	"./defaultLogo.svg": 20168,
	"./delete-icon.svg": 6668,
	"./delete-segment.svg": 66510,
	"./delete.svg": 31673,
	"./design-icon.svg": 10912,
	"./device-icon.svg": 2113,
	"./device-item-icon.svg": 17425,
	"./devices-icon.svg": 92774,
	"./documentIcon.svg": 61714,
	"./done.svg": 43207,
	"./dot-not-selected.svg": 7848,
	"./dot-selected.svg": 47583,
	"./dots.svg": 66459,
	"./download-qr-icon.svg": 48603,
	"./downloadIcon.svg": 9901,
	"./dragHandle.svg": 18851,
	"./drop-down-icon.svg": 39800,
	"./dropdown-icon-down.svg": 77593,
	"./dropdown-icon-up.svg": 52924,
	"./dropdown-icon.svg": 65314,
	"./edit-btn.svg": 84488,
	"./edit-campaign-icon.svg": 35275,
	"./edit-email.svg": 63996,
	"./edit-icon.svg": 44131,
	"./edit.svg": 76937,
	"./email-creator.svg": 37224,
	"./email-icon.svg": 48531,
	"./email-login.svg": 38856,
	"./email-return-rate.svg": 30900,
	"./emails-calendar.svg": 29943,
	"./emails-icon.svg": 88849,
	"./emails-open.svg": 13160,
	"./emails.svg": 42996,
	"./eye-show.svg": 52320,
	"./eye.svg": 76461,
	"./facebook-icon.svg": 2374,
	"./facebook.svg": 3536,
	"./fanicon.svg": 28930,
	"./fb-login.svg": 32912,
	"./fb-title-logo.svg": 72790,
	"./female.svg": 92506,
	"./finish-later-icon.svg": 77967,
	"./full-icon.svg": 96158,
	"./hamburger-menu-btn.svg": 25625,
	"./info.svg": 41710,
	"./instagram.svg": 55397,
	"./integration.svg": 51326,
	"./interface.svg": 48562,
	"./label-icon.svg": 63004,
	"./landing-page-icon.svg": 3395,
	"./landingTutorial.svg": 39282,
	"./left-arrow.svg": 47531,
	"./left.svg": 8723,
	"./lightGrayCalendar.svg": 32795,
	"./lightGrayDelete.svg": 70688,
	"./lightGrayEdit.svg": 32904,
	"./linkedin-icon.svg": 82654,
	"./location.svg": 3968,
	"./log-out-icon.svg": 95545,
	"./login.svg": 14608,
	"./lost-customers.svg": 71308,
	"./loyal-customers.svg": 61817,
	"./mail.svg": 36829,
	"./mailchimp.svg": 51445,
	"./male.svg": 81568,
	"./manage-campaign-icon.svg": 25584,
	"./manage-campaigns-icon.svg": 86831,
	"./marketing-icon-inactive.svg": 40096,
	"./marketing-icon.svg": 42502,
	"./mastercard.svg": 17914,
	"./menu-btn.svg": 44632,
	"./menu.svg": 28647,
	"./message-container.svg": 45768,
	"./message-preview.svg": 64735,
	"./messagebird.svg": 47460,
	"./mobile.svg": 90589,
	"./network-icon.svg": 68503,
	"./new-email-icon.svg": 93965,
	"./next.svg": 51593,
	"./nfc.svg": 86645,
	"./not-found.svg": 50374,
	"./open-rate-icon.svg": 78329,
	"./org-dashboard.svg": 89667,
	"./org-delete.svg": 55981,
	"./org-edit.svg": 81436,
	"./org-info.svg": 46503,
	"./org-suspend.svg": 69089,
	"./payment-failed.svg": 60117,
	"./payment-success.svg": 62584,
	"./paypal.svg": 26068,
	"./person-icon.svg": 97815,
	"./phone-hand-quick-send.svg": 49790,
	"./phone-icon.svg": 50934,
	"./phone.svg": 25244,
	"./pin.svg": 68725,
	"./plan-item-icon.svg": 85458,
	"./plusIcon.svg": 14750,
	"./pm-delete-icon.svg": 21961,
	"./position-icon-grey.svg": 80779,
	"./position-icon.svg": 70046,
	"./profile.svg": 26130,
	"./registration-drop-down-icon.svg": 84565,
	"./remember-me-box-selected.svg": 22306,
	"./remember-me-box.svg": 44922,
	"./remove-from-list.svg": 10450,
	"./remove-icon.svg": 37370,
	"./remove-widget-icon.svg": 704,
	"./remove.svg": 6523,
	"./reports-icon.svg": 32623,
	"./retry-icon.svg": 99539,
	"./right-arrow.svg": 30348,
	"./right.svg": 33334,
	"./roundFacebook.svg": 30890,
	"./roundLinkedin.svg": 941,
	"./roundMail.svg": 64431,
	"./roundTwitter.svg": 51384,
	"./save-segment.svg": 59508,
	"./save-template-icon.svg": 19948,
	"./search-icon.svg": 62637,
	"./search.svg": 73794,
	"./send-campaigns-icon.svg": 22735,
	"./send-email-icon.svg": 87402,
	"./send-icon-inactive.svg": 62711,
	"./send-icon.svg": 63971,
	"./send-test-email-icon.svg": 95807,
	"./sendSMSTutorial.svg": 83509,
	"./sendgrid-full.svg": 6307,
	"./settings-icon.svg": 55047,
	"./settings.svg": 45812,
	"./settingsIcon.svg": 83882,
	"./shop.svg": 29634,
	"./show-password.svg": 58825,
	"./small-icon.svg": 83336,
	"./sms-contacts-icon.svg": 37636,
	"./sms-icon-inactive.svg": 52683,
	"./sms-icon.svg": 98825,
	"./sms-plane.svg": 60632,
	"./smsTutorial.svg": 32846,
	"./start-new-icon.svg": 34943,
	"./support-icon.svg": 24060,
	"./supportTutorial.svg": 18338,
	"./switch-off.svg": 50423,
	"./switch-on.svg": 69658,
	"./symbols.svg": 62343,
	"./tag.svg": 95300,
	"./texts-failed-icon.svg": 52261,
	"./tick.svg": 62186,
	"./total-sent-icon.svg": 95212,
	"./total-sms-contacts-icon.svg": 52918,
	"./track&trace.svg": 465,
	"./tt-icon.svg": 99623,
	"./twitter-icon.svg": 37436,
	"./twitter-login.svg": 57969,
	"./twitter.svg": 37751,
	"./unaro-full-icon.svg": 74402,
	"./unaro-full.svg": 74057,
	"./unaro-main.svg": 44449,
	"./unaro-yellow-background.svg": 76846,
	"./unaro-yellow-bg copy.svg": 64978,
	"./unaro-yellow-bg.svg": 51841,
	"./unaro.svg": 41232,
	"./unsubscribed.svg": 93820,
	"./upcoming-birthdays.svg": 47438,
	"./upload-icon.svg": 60263,
	"./uploaded-file-icon.svg": 95741,
	"./user.svg": 13816,
	"./users-icon.svg": 61649,
	"./venueTutorial.svg": 43901,
	"./venues.svg": 2329,
	"./verify-icon.svg": 32652,
	"./visa.svg": 17676,
	"./warningIcon.svg": 92379,
	"./widgets/connect-chart.svg": 18197,
	"./widgets/customer-logins.svg": 93368,
	"./widgets/customers.svg": 71372,
	"./widgets/demographics.svg": 38420,
	"./widgets/emails-collected.svg": 47820,
	"./widgets/send-calendar.svg": 22130,
	"./widgets/send-clicks.svg": 4016,
	"./widgets/send-failed.svg": 87490,
	"./widgets/send-open-rate.svg": 2651,
	"./widgets/send-opens.svg": 33332,
	"./widgets/sms-campaigns-list.svg": 72756,
	"./widgets/sms-campaigns.svg": 35854,
	"./widgets/sms-sent.svg": 12936,
	"./widgets/sms-spent.svg": 74869,
	"./wifi-icon.svg": 79753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29866;